const dogKeywords = ['dog','dogs','puppy','puppies','canine','pet-friendly','pets allowed','no dogs','leash','off-leash','dog-friendly'];

export function mentionsDogs(text: string = ''): boolean {
  const lower = text.toLowerCase();
  return dogKeywords.some(keyword => lower.includes(keyword));
}
